module.exports = __webpack_public_path__ + "static/css3-dc1c47c7ca5afd9dfb6394d502475132.svg";